import BsjSetMaxSpeedModal from './bsj-set-max-speed-modal.vue'
export default BsjSetMaxSpeedModal
